<template>
    <div>
        <div class="flex">
              <div class="left-box bg-color flex align-end" :style="{background:`url(${list[0].litpic})`}" @click="handleClick(list[0].id)">
                        <div class="left-box-des">
                            <div class="zhezhao" style="margin-top:60px;padding:30px">
                                <p class="title-b">{{list[0].title}}</p>
                                <p class="content-b">{{list[0].seo_description}}</p>
                            </div>
                            
                        </div>
              </div>

                    <div class="right-box flex-first">
                        <div class="flex right-top-box justify-end bg-color" :style="{background:`url(${list[1].litpic})`}" @click="handleClick(list[1].id)">
                            <div class="zhezhao" style="width:250px;padding:30px;">
                                <p class="title-b">{{list[1].title}}</p>
                                <p class="content-b">{{list[1].seo_description}}</p>
                            </div>
                        </div>
                        <div class="flex align-end right-bottom-box bg-color" :style="{background:`url(${list[2].litpic})`}" @click="handleClick(list[2].id)">
                            <div class="zhezhao">
                                <p class="title-b">{{list[2].title}}</p>
                                <p class="content-b">{{list[2].seo_description}}</p>
                            </div>
                        </div>
                    </div>
                </div>
         
    </div>
</template>

<script>
    export default {
        name: 'curtain',
        data() {
            return {
                
            }
        },
        props:{
            list:{
                type:Array,
                default(){
                    return []
                }
            },
        },
        methods:{
            handleClick(id){
     
                this.$emit('jump',id)
            },
        }
    }
</script>

<style lang="scss" scoped>
    .bg-color{
        background: #CDB499;
    }
    .left-box{
        height:500px;
        width: 350px;
        margin-right:30px;
        cursor: pointer;
        
    }
    .left-box-des{
        width: 100%;
        /* height: 200px; */
        /* background:rgba(40,40,40,1);
        opacity:0.6; */
    }
    .title-b{
        font-size:18px;
        font-weight:400;
        color:#fff;
   
    }
    .content-b{
        font-size:12px;
        font-weight:400;
        color:#fff;
   
    }

    .right-top-box{
        width: 500px;
        height: 235px;
        margin-bottom: 30px;
        cursor: pointer;
        
    }
    .right-top-box>div{
        /* background:rgba(40,40,40,1);
        opacity:0.6; */
    }
    .right-bottom-box{
        width: 500px;
        height: 235px;
        cursor: pointer;
    }
    .right-bottom-box>div{
        /* background:rgba(40,40,40,1);
        opacity:0.6; */
        height: 117px;
        padding: 30px;
        width:100%;
    }
    .zhezhao{
        padding: 25px;
    }
    .zhezhao:hover{
		background:#f7f8f8;
        opacity:0.8; 
        p {
            color: #666;
        }

	}
</style>